<template>
  <div class="hzc-coke">
    <div class="content container">
      <div class="banner-left" @click="changeIndustrial">
        <p class="banner-title">{{ chainTitle }}</p>
        <div class="data1">{{ data1['druidParamName'] }}<em v-if="data1['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data1['price'] }}</span></div>
        <div class="data2">{{ `${data2['druidParamName']}` }}<em v-if="data2['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data2['price'] }}</span>
        </div>
        <div class="data3">{{ `${data3['druidParamName']}` }}<em v-if="data3['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data3['price'] }}</span>
        </div>
        <div class="data4">{{ `${data4['druidParamName']}` }}<em v-if="data4['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data4['price'] }}</span>
        </div>
        <div class="data5">{{ `${data5['druidParamName']}` }}<em v-if="data5['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data5['price'] }}</span>
        </div>
        <div class="data6">{{ `${data6['druidParamName']}` }}<em v-if="data6['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data6['price'] }}</span>
        </div>
        <div class="data7">{{ `${data7['druidParamName']}` }}<em v-if="data7['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data7['price'] }}</span>
        </div>
        <div class="data8">{{ `${data8['druidParamName']}` }}<em v-if="data8['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data8['price'] }}</span>
        </div>
        <div class="data9">{{ `${data9['druidParamName']}` }}<em v-if="data9['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data9['price'] }}</span>
        </div>
        <div class="data10">{{ `${data10['druidParamName']}` }}<em v-if="data10['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data10['price'] }}</span>
        </div>
        <div class="data11">{{ `${data11['druidParamName']}` }}<em v-if="data11['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data11['price'] }}</span>
        </div>
        <div class="data12">{{ `${data12['druidParamName']}` }}<em v-if="data12['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data12['price'] }}</span>
        </div>
        <div class="differPrice1 redColor" v-if="chainPrice['differPrice1'] > 0">
          {{ '+' + chainPrice['differPrice1'] }}
        </div>
        <div class="differPrice1 greenColor" v-if="chainPrice['differPrice1'] < 0">{{ chainPrice['differPrice1'] }}
        </div>
        <div class="differPrice1" v-if="chainPrice['differPrice1'] === 0">—</div>
        <div class="differPrice2 redColor" v-if="chainPrice['differPrice2'] > 0">
          {{ '+' + chainPrice['differPrice2'] }}
        </div>
        <div class="differPrice2 greenColor" v-if="chainPrice['differPrice2'] < 0">{{ chainPrice['differPrice2'] }}
        </div>
        <div class="differPrice2" v-if="chainPrice['differPrice2'] === 0">—</div>
        <div class="differPrice3 redColor" v-if="chainPrice['differPrice3'] > 0">
          {{ '+' + chainPrice['differPrice3'] }}
        </div>
        <div class="differPrice3 greenColor" v-if="chainPrice['differPrice3'] < 0">{{ chainPrice['differPrice3'] }}
        </div>
        <div class="differPrice3" v-if="chainPrice['differPrice3'] === 0">—</div>
        <div class="differPrice4 redColor" v-if="chainPrice['differPrice4'] > 0">
          {{ '+' + chainPrice['differPrice4'] }}
        </div>
        <div class="differPrice4 greenColor" v-if="chainPrice['differPrice4'] < 0">{{ chainPrice['differPrice4'] }}
        </div>
        <div class="differPrice4" v-if="chainPrice['differPrice4'] === 0">—</div>
        <div class="differPrice5 redColor" v-if="chainPrice['differPrice5'] > 0">
          {{ '+' + chainPrice['differPrice5'] }}
        </div>
        <div class="differPrice5 greenColor" v-if="chainPrice['differPrice5'] < 0">{{ chainPrice['differPrice5'] }}
        </div>
        <div class="differPrice5" v-if="chainPrice['differPrice5'] === 0">—</div>
        <div class="differPrice6 redColor" v-if="chainPrice['differPrice6'] > 0">
          {{ '+' + chainPrice['differPrice6'] }}
        </div>
        <div class="differPrice6 greenColor" v-if="chainPrice['differPrice6'] < 0">{{ chainPrice['differPrice6'] }}
        </div>
        <div class="differPrice6" v-if="chainPrice['differPrice6'] === 0">—</div>
        <div class="differPrice7 redColor" v-if="chainPrice['differPrice7'] > 0">
          {{ '+' + chainPrice['differPrice7'] }}
        </div>
        <div class="differPrice7 greenColor" v-if="chainPrice['differPrice7'] < 0">{{ chainPrice['differPrice7'] }}
        </div>
        <div class="differPrice7" v-if="chainPrice['differPrice7'] === 0">—</div>
        <div class="differPrice8 redColor" v-if="chainPrice['differPrice8'] > 0">
          {{ '+' + chainPrice['differPrice8'] }}
        </div>
        <div class="differPrice8 greenColor" v-if="chainPrice['differPrice8'] < 0">{{ chainPrice['differPrice8'] }}
        </div>
        <div class="differPrice8" v-if="chainPrice['differPrice8'] === 0">—</div>
        <div class="differPrice9 redColor" v-if="chainPrice['differPrice9'] > 0">
          {{ '+' + chainPrice['differPrice9'] }}
        </div>
        <div class="differPrice9 greenColor" v-if="chainPrice['differPrice9'] < 0">{{ chainPrice['differPrice9'] }}
        </div>
        <div class="differPrice9" v-if="chainPrice['differPrice9'] === 0">—</div>
        <div class="differPrice10 redColor" v-if="chainPrice['differPrice10'] > 0">
          {{ '+' + chainPrice['differPrice10'] }}
        </div>
        <div class="differPrice10 greenColor" v-if="chainPrice['differPrice10'] < 0">{{ chainPrice['differPrice10'] }}
        </div>
        <div class="differPrice10" v-if="chainPrice['differPrice10'] === 0">—</div>
      </div>
      <div class="banner-right">
        <div class="title">
          <div class="title-write"
               :class="{'title-write-red' : true}">新闻资讯
          </div>
          <span class="title-more fr" @click="toTwoPage('/zetar/twoPage/industry')">更多 ></span>
        </div>
        <div class="banner-right-content">
          <ul>
            <li v-for="(item, index) in industryList" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/zetar/industry', item.id, 2)">{{ item.titleName }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="classification">
      <ul class="clearfix">
        <li>
          <ClassificationHeader :name="'价格'" :flag="false" :unit="false"
                                :params="{title:'价格',typeList:['区域价格', '招标价格','进出口价格']}"
                                :url="'/zetar/twoPage/price'"></ClassificationHeader>
          <span class="classification-tabs-two" @mouseover="priceFlag = 'issue_material_add_area_price'"
                style="width:124px;"
                @click="toTwoPage('/zetar/twoPage/price', 'issue_material_add_area_price')"
                :class="{'stockFlag':priceFlag === 'issue_material_add_area_price'}">区域价格</span>
          <span class="classification-tabs-two" @mouseover="priceFlag = '57'"
                style="width:124px;"
                @click="toTwoPage('/zetar/twoPage/price', '57')"
                :class="{'stockFlag':priceFlag === '57'}">招标价格</span>
          <span class="classification-tabs-two" @mouseover="priceFlag = '58'"
                @click="toTwoPage('/zetar/twoPage/price', '58')"
                style="width:124px;"
                :class="{'stockFlag':priceFlag === '58'}">进出口价格</span>
          <div class="classification-content" style="margin-top: 4px"
               v-if="priceFlag === 'issue_material_add_area_price'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;"
                 v-for="(item, index) in priceOneList" :key="index"
                 @click="goDetail('/zetar/price', item.completeOriginalDate, 'issue_material_add_area_price')">
              <i></i>
              <p>{{ item.date + '煤焦油区域价格' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px" v-if="priceFlag === '57'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;"
                 v-for="(item, index) in priceTwoList" :key="index"
                 @click="goDetail('/zetar/backPrice', item.id, '57')">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px" v-if="priceFlag === '58'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;"
                 v-for="(item, index) in priceThreeList" :key="index"
                 @click="goDetail('/zetar/backPrice', item.id, '58')">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'产量'" :flag="true" :unit="false" :url="'/zetar/twoPage/yield'"
                                :params="{title:'产量'}"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in yieldList" :key="index"
                 @click="goDetail('/zetar/yield', item.id)">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <div class="head" style="border-bottom: none">
            <em></em>
            <p>研究报告</p>
            <span class="fr" @click="toTwoPage('/zetar/twoPage/report')"> >></span>
            <img src="../../assets/home/neibu.png" style="width: 70px;margin-left: 10px;" alt="">
            <div class="report-tabs">
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 1}"
                   @click="reportToPage('/zetar/twoPage/report', 1)" @mouseover="changeReportFlag(1)">日报
              </div>
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 2}"
                   @click="reportToPage('/zetar/twoPage/report', 2)" @mouseover="changeReportFlag(2)">周报
              </div>
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 3}"
                   @click="reportToPage('/zetar/twoPage/report', 3)" @mouseover="changeReportFlag(3)">月报
              </div>
            </div>
          </div>
          <div class="classification-content research">
            <img style="width: 360px" src="../../assets/home/yanjiubaogao.png" alt="">
            <div v-if="reportFlag === 1">
              <div class="classification-content-div" v-for="(item, index) in reportList" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 2">
              <div class="classification-content-div" v-for="(item, index) in reportListWeek" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 3">
              <div class="classification-content-div" v-for="(item, index) in reportListMonth" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'深加工开工率'" :flag="true" :unit="false" :url="'/zetar/twoPage/rate'"
                                :params="{title:'深加工开工率'}"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in rateList" :key="index">
              <i></i>
              <p style="width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                 @click="goDetail('/zetar/rate', item.completeOriginalDate)">{{ item.date + '煤焦油开工率' }}</p>
              <span class="fr" style="color: #777777;font-size: 12px;">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li style="position:relative">
          <img src="../../assets/home/lirunwu.png" alt="">
          <span style="font-size: 24px;font-weight: 500;color: #fff;position: absolute;top: 20px;left: 20px;">利润</span>
          <span @click="toTwoPage('/zetar/twoPage/profit')"
                style="right: 10px;position: absolute;top: 24px;color: #fff;cursor: pointer;"> >></span>
          <div class="classification-content" style="margin-top: -5px;">
            <div class="classification-content-div" v-for="(item, index) in profitList" :key="index"
                 @click="goDetail('/zetar/profit', item.completeOriginalDate)">
              <i></i>
              <p>{{ item.date + '煤焦油利润' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li style="position: relative">
          <img src="../../assets/methanol/dashuju.png" alt="">
          <span style="position: absolute;right: 10px;top: 27px;cursor: pointer;color:#fff;opacity: 0"
                @click="toTwoPage('/zetar/twoPage/forecast', JSON.stringify({url:'/zetar', varieties: '煤焦油'}))"> >></span>
          <img src="../../assets/home/neibu.png" style="width: 70px;position: absolute;left: 200px;top: 25px;" alt="">
          <div class="classification-content">
            <div class="classification-content-div map" v-for="(item, index) in forecastList"
                 @click="goDetail('/zetar/forecast', item.id, '/zetar', '煤焦油' )" :key="index">
              <i></i>
              <p>{{ item.showYearTime + item.predictType + '价格预测' }}</p>
              <span class="fr">{{ item.showEndTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'进出口'" :flag="true" :unit="false"
                                :url="'/zetar/twoPage/exit'"></ClassificationHeader>
          <div class="classification-content" style="margin-top: 4px">
            <div class="classification-content-div" v-for="(item, index) in exitList" :key="index"
                 @click="goDetail('/zetar/exit', item.id)">
              <i></i>
              <p>{{ item.titleName}}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'装置动态'" :flag="true" :unit="false"
                                :url="'/zetar/twoPage/device'"></ClassificationHeader>
          <div class="classification-content" style="margin-top: 4px">
            <div class="classification-content-div" v-for="(item, index) in deviceList" :key="index"
                 @click="goDetail('/zetar/device', item.id)">
              <i></i>
              <p>{{ item.titleName}}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <div class="head" style="border-bottom: none;">
            <em></em>
            <p>企业分布 <b style="color: #D3131A;font-size: 18px;margin-left: -5px;font-weight: normal">地图</b></p>
            <img src="../../assets/home/neibu.png" style="width: 70px;margin-left: 10px;" alt="">
          </div>
          <div class="classification-content">
            <img style="cursor: pointer" src="../../assets/home/map.png" @click="goDetail('/zetar/map')" alt="">
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'下游产品价格'" :flag="false" :unit="false"
                                :params="{title:'下游产品价格',typeList:['蒽油市场价格', '炭黑价格']}"
                                :url="'/zetar/twoPage/downPrice'"></ClassificationHeader>
          <span class="classification-tabs-two" @mouseover="downPriceFlag = 'issue_coal_add_down_price_oil'"
                @click="toTwoPage('/zetar/twoPage/downPrice', 'issue_coal_add_down_price_oil')"
                style="width:186px;"
                :class="{'stockFlag':downPriceFlag === 'issue_coal_add_down_price_oil'}">蒽油市场价格</span>
          <span class="classification-tabs-two" @mouseover="downPriceFlag = 'issue_coal_add_down_price_black'"
                @click="toTwoPage('/zetar/twoPage/downPrice', 'issue_coal_add_down_price_black')"
                style="width:186px;"
                :class="{'stockFlag':downPriceFlag === 'issue_coal_add_down_price_black'}">炭黑价格</span>
          <div class="classification-content" style="margin-top: 4px"
               v-if="downPriceFlag === 'issue_coal_add_down_price_oil'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;"
                 v-for="(item, index) in downPriceOne" :key="index"
                 @click="goDetail('/zetar/downPrice', item.completeOriginalDate, 'issue_coal_add_down_price_oil')">
              <i></i>
              <p>{{ item.date + '蒽油市场价格' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px" v-if="downPriceFlag === 'issue_coal_add_down_price_black'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;"
                 v-for="(item, index) in downPriceTwo" :key="index"
                 @click="goDetail('/zetar/downPrice', item.completeOriginalDate, 'issue_coal_add_down_price_black')">
              <i></i>
              <p>{{ item.date + '炭黑价格' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'下游产品开工率'" :flag="false" :unit="false"
                                :params="{title:'下游产品开工率',typeList:['炭黑', '轮胎']}"
                                :url="'/zetar/twoPage/downRate'"></ClassificationHeader>
          <span class="classification-tabs-two" @mouseover="downRateFlag = '62'"
                @click="toTwoPage('/zetar/twoPage/downRate', '62')"
                style="width:186px;"
                :class="{'stockFlag':downRateFlag === '62'}">炭黑</span>
          <span class="classification-tabs-two" @mouseover="downRateFlag = 'issue_coal_add_down_rate'"
                @click="toTwoPage('/zetar/twoPage/downRate', 'issue_coal_add_down_rate')"
                style="width:186px;"
                :class="{'stockFlag':downRateFlag === 'issue_coal_add_down_rate'}">轮胎</span>
          <div class="classification-content" style="margin-top: 4px"
               v-if="downRateFlag === '62'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;"
                 v-for="(item, index) in downRateOne" :key="index"
                 @click="goDetail('/zetar/downRateXin', item.id, '62')">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px" v-if="downRateFlag === 'issue_coal_add_down_rate'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;"
                 v-for="(item, index) in downPriceTwo" :key="index"
                 @click="goDetail('/zetar/downRate', item.completeOriginalDate, 'issue_coal_add_down_rate')">
              <i></i>
              <p>{{ item.date + '轮胎开工率' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'下游产品产量'" :flag="false" :unit="false"
                                :params="{title:'下游产品产量',typeList:['蒽油', '炭黑', '轮胎']}"
                                :url="'/zetar/twoPage/downYield'"></ClassificationHeader>
          <span class="classification-tabs-two" @mouseover="downYieldFlag = '64'"
                style="width:124px;"
                @click="toTwoPage('/zetar/twoPage/downYield', '64')"
                :class="{'stockFlag':downYieldFlag === '64'}">蒽油</span>
          <span class="classification-tabs-two" @mouseover="downYieldFlag = '63'"
                @click="toTwoPage('/zetar/twoPage/downYield', '63')"
                style="width:124px;"
                :class="{'stockFlag':downYieldFlag === '63'}">炭黑</span>
          <span class="classification-tabs-two" @mouseover="downYieldFlag = 'issue_coal_add_down_yield'"
                @click="toTwoPage('/zetar/twoPage/downYield', 'issue_coal_add_down_yield')"
                style="width:124px;"
                :class="{'stockFlag':downYieldFlag === 'issue_coal_add_down_yield'}">轮胎</span>
          <div class="classification-content" style="margin-top: 4px"
               v-if="downYieldFlag === '64'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;"
                 v-for="(item, index) in downYieldOne" :key="index"
                 @click="goDetail('/zetar/downYieldXin', item.id, '64')">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="downYieldFlag === '63'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;"
                 v-for="(item, index) in downYieldTwo" :key="index"
                 @click="goDetail('/zetar/downYieldXin', item.id, '63')">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px" v-if="downYieldFlag === 'issue_coal_add_down_yield'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;"
                 v-for="(item, index) in downYieldThree" :key="index"
                 @click="goDetail('/zetar/downYield', item.completeOriginalDate, 'issue_coal_add_down_yield')">
              <i></i>
              <p>{{ item.date + '轮胎产量' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'下游产品进出口'" :flag="true" :unit="false" :url="'/zetar/twoPage/downExit'"
                                :params="{title:'下游产品进出口'}"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in downExitList" :key="index"
                 @click="goDetail('/zetar/downExit', item.completeOriginalDate, 'issue_coal_add_down_exit')">
              <i></i>
              <p>{{ item.date + '下游产品进出口' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <img src="../../assets/home/lirunwu.png" alt="">
          <span style="font-size: 24px;font-weight: 500;color: #fff;position: absolute;top: 20px;left: 20px;">下游产品利润</span>
          <span @click="toTwoPage('/zetar/twoPage/downProfit')"
                style="right: 10px;position: absolute;top: 24px;color: #fff;cursor: pointer;"> >></span>
          <div class="classification-content" style="margin-top: -5px;">
            <div class="classification-content-div" v-for="(item, index) in downProfitList" :key="index"
                 @click="goDetail('/zetar/downProfit', item.completeOriginalDate, 'issue_coal_add_down_profit')">
              <i></i>
              <p>{{ item.date + '炭黑利润' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'技术及标准'" :flag="true" :unit="false" :url="'/zetar/twoPage/standard'" :neibu="true"
                                :params="{title:'技术及标准'}"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in standardList" :key="index">
              <i></i>
              <p style="width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                 @click="downloadStandard(item)">{{ item.fileTitle }}</p>
              <span class="fr" style="color: #777777;font-size: 12px;">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <el-dialog custom-class="previewDialog" :destroy-on-close="true" :close-on-click-modal="false" width="1194px"
               :visible.sync="industrialFlag">
      <MaterialIndustrial @closeIndustrialCh="closeIndustrial" v-if="industrialFlag"></MaterialIndustrial>
    </el-dialog>
  </div>
</template>

<script>
import {
  industryNoAuthList,industryDetail, zetarPriceNoAuthList, zetarReportNoAuthList, rateNoAuthList, downYieldNoAuthList, downExitNoAuthList,chainList,zetarReportDetail, standardDetail
} from '@/api/zetar'
import {zetarForecasNoAuthtList} from "@/api";
import ClassificationHeader from '@/components/common/ClassificationHeader'
import Expect from '@/components/common/expect'
import MaterialIndustrial from '@/components/bigChart/materialIndustrial'

export default {
  components: {
    ClassificationHeader,
    MaterialIndustrial,
    Expect,
  },
  data() {
    return {
      industryFlag: 2,
      industrialFlag: false,
      // 行业动态
      industryList: [],
      // 研究报告
      reportList: [],
      reportListWeek: [],
      reportListMonth: [],
      reportFlag: 2,
      // 价格指数
      priceFlag: 'issue_material_add_area_price',
      priceOneList: [],
      priceTwoList: [],
      priceThreeList: [],
      // 开工率
      rateList:[],
      // 开工率
      exitList:[],
      // 产量
      yieldList:[],
      // 利润
      profitList:[],
      // 价格预测
      forecastList:[],
      // 装置动态
      deviceList:[],
      // 下游产品价格
      downPriceFlag:'issue_coal_add_down_price_oil',
      downPriceOne:[],
      downPriceTwo:[],
      // 下游产品开工率
      downRateFlag:'62',
      downRateOne:[],
      downRateTwo:[],
      // 下游产品产量
      downYieldFlag:'63',
      downYieldOne:[],
      downYieldTwo:[],
      downYieldThree:[],
      // 下游产品进出口
      downExitList:[],
      // 下游产品利润
      downProfitList:[],
      // 行业标准
      standardList: [],
      // 产业链
      chainTitle: '',
      data1: {},
      data2: {},
      data3: {},
      data4: {},
      data5: {},
      data6: {},
      data7: {},
      data8: {},
      data9: {},
      data10: {},
      data11: {},
      data12: {},
      chainPrice: {},
    }
  },
  created() {
    this.getHomeList()
  },
  methods: {
    /**
     * 获取首页信息
     */
    getHomeList() {
      // 产业链
      chainList({dictDataType: 'issue_coal_add_small_chain'}).then(res => {
        this.chainTitle = res.data['data1']['date'];
        this.data1 = res.data['data1'];
        this.data2 = res.data['data2'];
        this.data3 = res.data['data3'];
        this.data4 = res.data['data4'];
        this.data5 = res.data['data5'];
        this.data6 = res.data['data6'];
        this.data7 = res.data['data7'];
        this.data8 = res.data['data8'];
        this.data9 = res.data['data9'];
        this.data10 = res.data['data10'];
        this.data11 = res.data['data11'];
        this.data12 = res.data['data12'];
        this.chainPrice = res.data['price'];
      })
      // 行业动态
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 92}).then(res => {
        this.industryList = res.rows;
      })
      // 价格指数
      zetarPriceNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_material_add_area_price'}).then(res => {
        this.priceOneList = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: 57}).then(res => {
        this.priceTwoList = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: 58}).then(res => {
        this.priceThreeList = res.rows;
      })
      // 产量
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 60}).then(res => {
        this.yieldList = res.rows;
      })
      // 开工率
      rateNoAuthList({pageNum: 1, pageSize: 8, dictDataType: 'issue_coal_add_rate'}).then(res => {
        this.rateList = res.rows;
      })
      // 研究报告
      zetarReportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 6, fileType: 1}).then(res => {
        this.reportList = res.rows;
      })
      zetarReportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 6, fileType: 2}).then(res => {
        this.reportListWeek = res.rows;
      })
      zetarReportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 6, fileType: 3}).then(res => {
        this.reportListMonth = res.rows;
      })
      // 利润
      zetarPriceNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_coal_add_profit'}).then(res => {
        this.profitList = res.rows;
      })
      // 价格预测
      zetarForecasNoAuthtList({pageNum: 1, pageSize: 7, varieties:'煤焦油'}).then(res => {
        this.forecastList = res.rows;
      })
      // 进出口
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 59}).then(res => {
        this.exitList = res.rows;
      })
      // 装置动态
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 61}).then(res => {
        this.deviceList = res.rows;
      })
      // 下游产品价格
      zetarPriceNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_coal_add_down_price_oil'}).then(res => {
        this.downPriceOne = res.rows;
      })
      zetarPriceNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_coal_add_down_price_black'}).then(res => {
        this.downPriceTwo = res.rows;
      })
      // 下游产品开工率
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: '62'}).then(res => {
        this.downRateOne = res.rows;
      })
      rateNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_coal_add_down_rate'}).then(res => {
        this.downRateTwo = res.rows;
      })
      // 下游产品产量
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: '64'}).then(res => {
        this.downYieldOne = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: '63'}).then(res => {
        this.downYieldTwo = res.rows;
      })
      downYieldNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_coal_add_down_yield'}).then(res => {
        this.downYieldThree = res.rows;
      })
      // 下游产品进出口
      downExitNoAuthList({pageNum: 1, pageSize: 8, dictDataType: 'issue_coal_add_down_exit'}).then(res => {
        this.downExitList = res.rows;
      })
      // 下游产品利润
      zetarPriceNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_coal_add_down_profit'}).then(res => {
        this.downProfitList = res.rows;
      })
      // 技术及标准
      zetarReportNoAuthList({pageNum: 1, pageSize: 8, sourceType: 6, fileType: 4}).then(res => {
        this.standardList = res.rows;
      })
    },
    /**
     * 前往行业报告二级
     */
    reportToPage(url, flag) {
      this.$router.push({path: url, query: {flag}})
    },
    /**
     * 打开关闭模态
     */
    changeIndustrial() {
      this.industrialFlag = true;
    },
    closeIndustrial() {
      this.industrialFlag = false;
    },
    /**
     *  行业动态外链
     */
    openUrl(item) {
      industryDetail(item['id']).then(() => {
        window.openUrl(item.newsContent)
      })
    },
    /**
     * 预览文件
     */
    downloadReport(row) {
      zetarReportDetail(row['id'] + '/1').then((res) => {
        this.$setMenuInfoPath(['煤焦油加工', '研究报告', '正文'], row['id']);
      })
    },
    downloadStandard(row) {
      standardDetail(row['id'] + '/1').then((res) => {
        this.$setMenuInfoPath(['煤焦油加工', '技术及标准', '正文'], row['id']);
      })
    },
    /**
     * 切换tabs
     */
    changeFlag(flag) {
      this.industryFlag = flag;
    },
    /**
     * 切换研究报告tabs
     */
    changeReportFlag(flag) {
      this.reportFlag = flag;
    },
    /**
     * 跳转二级页
     * @param url
     */
    toTwoPage(url, flag, num) {
      this.$router.push({path: `${url}`, query: {flag, num}});
    },
    /**
     * 跳转详情页
     */
    goDetail(url, id, flag, other) {
      this.$router.push({path: `${url}`, query: {id, flag, other}})
    },
  },
}
</script>

<style scoped lang="less">

.report-tabs {
  position: absolute;
  top: 3px;
  right: 11px;

  .tabs-i {
    display: inline-block;
    font-style: normal;
    margin-right: 10px;
    cursor: pointer;
    font-size: 14px;
  }

  .tabs-i:hover {
    color: #D3131A;
    border-bottom: 2px solid #D3131A;
  }
}

.tabs-i-hover {
  color: #D3131A;
  border-bottom: 2px solid #D3131A;
}

.content {
  height: 355px;
  width: 1200px;
  margin: 0 auto;

  .banner-left {
    width: 650px;
    height: 360px;
    display: inline-block;
    background: url("../../assets/images/meijiaoyoubanner.png");
    background-size: 100% 100%;
    color: #fff;
    position: relative;
    cursor: pointer;

    img {
      width: 650px;
      height: 360px;
    }

    .banner-title {
      position: absolute;
      color: #B2F0E4;
      top: 31px;
      left: 248px;
      font-size: 12px;
    }

    .data1 {
      font-size: 10px;
      position: absolute;
      top: 143px;
      left: 88px;
      width: 96px;
      height: 50px;
    }

    .data2 {
      font-size: 10px;
      position: absolute;
      top: 303px;
      left: 83px;
      width: 104px;
      height: 50px;
    }

    .data3 {
      font-size: 10px;
      position: absolute;
      top: 84px;
      left: 253px;
      width: 95px;
      height: 50px;
    }

    .data4 {
      font-size: 10px;
      position: absolute;
      top: 162px;
      left: 252px;
      width: 95px;
      height: 50px;
    }

    .data5 {
      font-size: 10px;
      position: absolute;
      top: 238px;
      left: 252px;
      width: 95px;
      height: 50px;
    }

    .data6 {
      font-size: 10px;
      position: absolute;
      top: 313px;
      left: 249px;
      width: 104px;
      height: 50px;
      line-height: 14px;
    }

    .data7 {
      font-size: 10px;
      position: absolute;
      top: 83px;
      left: 403px;
      width: 95px;
      height: 50px;
    }

    .data8 {
      font-size: 10px;
      position: absolute;
      top: 166px;
      left: 399px;
      width: 103px;
      height: 50px;
    }

    .data9 {
      font-size: 10px;
      position: absolute;
      top: 241px;
      left: 399px;
      width: 103px;
      height: 50px;
    }

    .data10 {
      font-size: 10px;
      position: absolute;
      top: 83px;
      left: 545px;
      width: 103px;
      height: 50px;
    }

    .data11 {
      font-size: 8px;
      position: absolute;
      top: 192px;
      left: 545px;
      width: 100px;
      height: 50px;
    }

    .data12 {
      font-size: 10px;
      position: absolute;
      top: 280px;
      left: 548px;
      width: 90px;
      height: 50px;
    }

    .differPrice1 {
      position: absolute;
      top: 81px;
      left: 204px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice2 {
      position: absolute;
      top: 149px;
      left: 204px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice3 {
      position: absolute;
      top: 227px;
      left: 204px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice4 {
      position: absolute;
      top: 300px;
      left: 204px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice5 {
      position: absolute;
      top: 72px;
      left: 358px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice6 {
      position: absolute;
      top: 151px;
      left: 355px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice7 {
      position: absolute;
      top: 225px;
      left: 358px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice8 {
      position: absolute;
      top: 73px;
      left: 505px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice9 {
      position: absolute;
      top: 188px;
      left: 505px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice10 {
      position: absolute;
      top: 280px;
      left: 505px;
      width: 25px;
      height: 25px;
      text-align: center;
    }
  }

  .banner-right {
    width: 510px;
    height: 360px;
    margin-left: 40px;
    display: inline-block;
    vertical-align: top;

    .title {
      width: 100%;
      border-bottom: 1px solid #ccc;
      height: 36px;
      line-height: 36px;

      .title-write {
        display: inline-block;
        width: 96px;
        height: 36px;
        border-radius: 4px 4px 0px 0px;
        text-align: center;
        line-height: 36px;
        color: #333;
      }

      .title-write-red {
        color: #fff;
        background: #D3131A;
      }

      .title-more {
        cursor: pointer;
        color: #666666;
        font-size: 12px;
      }
    }

    .banner-right-content {
      ul {
        li {
          margin-top: 11px;

          p {
            display: inline-block;
            width: fit-content;
            max-width: 450px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 20px;
            line-height: 20px;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {
            color: #D3131A;
            //border-bottom: 1px solid #D3131A;
            text-decoration: underline;
          }

          span {
            display: inline-block;
            height: 20px;
            font-size: 12px;
            color: #777777;
            line-height: 20px;
          }
        }
      }
    }
  }
}

.classification {
  width: 1200px;
  margin: 0 auto;
  padding-top: 39px;

  ul {
    li {
      float: left;
      width: 372px;
      margin-right: 42px;
      height: 300px;
      margin-bottom: 43px;
      position: relative;

      img {
        width: 372px;
      }

      .head {
        color: #222222;
        height: 35px;
        font-size: 18px;
        line-height: 30px;
        position: relative;
        border-bottom: 2px solid #ccc;

        .red-title {
          width: 168px;
          height: 36px;
          background: #D3131A;
          border-radius: 4px 4px 0px 0px;
          color: #fff;
          text-align: center;
          line-height: 36px;
        }

        i {
          width: 60px;
          height: 2px;
          background: #CCCCCC;
          display: inline-block;
          position: absolute;
          bottom: 0;
        }

        em {
          width: 4px;
          height: 18px;
          background: #D3131A;
          font-style: normal;
          display: inline-block;
          margin-right: 9px;
          vertical-align: middle;
        }

        img {
          vertical-align: middle;
          margin-right: 9px;

        }

        p {
          font-size: 18px;
          display: inline-block;
          vertical-align: middle;
        }

        span {
          font-size: 12px;
          cursor: pointer;
          height: 20px;
          border-bottom: 1px solid #fff;
        }

        span:hover {
          border-bottom: 1px solid #222;
        }
      }

      .classification-tabs-two {
        width: 93px;
        height: 34px;
        line-height: 34px;
        display: inline-block;
        background: #F2F2F2;
        border-top: 2px solid #F2F2F2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .priceFlag {
        border-top: 2px solid #D3131A;
        background-color: #fff;
      }

      .classification-tabs-two:hover {
        border-top: 2px solid #D3131A;
        background: #D3131A;
        color: #fff;
      }

      .classification-tabs-three {
        width: 93px;
        height: 36px;
        line-height: 34px;
        display: inline-block;
        background: #F2F2F2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .stockFlag {
        background: #D3131A;
        color: #fff;
      }

      .classification-tabs-three:hover {
        background-color: #D3131A;
        color: #fff;
      }

      .classification-content {
        .classification-content-div {
          height: 33px;
          line-height: 33px;

          i {
            width: 4px;
            height: 4px;
            background: #9B857B;
            display: inline-block;
            margin-right: 5px;
            border-radius: 50%;
          }

          p {
            width: 250px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            vertical-align: middle;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {

            color: #D3131A;
            text-decoration: underline;
            //border-bottom: 1px solid #D3131A;
          }

          span {
            color: #777777;
            font-size: 12px;
          }

        }

        .price {
          height: 33px;
          line-height: 33px;
          padding: 0 10px;

          img {
            margin-right: 5px;
            width: 8px;
          }
        }

        .price:nth-child(2n+0) {
          background: #F2F2F2;
        }
      }

      .research {
        width: 360px;
        height: 262px;
        border-radius: 0px 0px 4px 4px;
        border: 6px solid #DDDDDD;

        .classification-content-div {
          border-bottom: 1px dashed rgba(211, 19, 26, 0.25);
          height: 35px;
          line-height: 35px;
          margin-top: -1px;

          i {
            margin-left: 5px;
          }

          span {
            margin-right: 5px;
          }
        }

        .classification-content-div:last-child {
          border-bottom: none;
        }
      }
    }

    li:nth-child(3n+0) {
      margin-right: 0;
    }
  }
}

.exitClass {
  .classification-content-div {
    margin-top: 8px;
  }

  p {
    max-width: 200px;
    display: inline-block;
    cursor: pointer;
    // 透明border
    border-style: solid;
    border-width: 1px;
    border-color: transparent;
  }

  p:hover {
    color: #D3131A;
    //border-bottom: 1px solid #D3131A;
    text-decoration: underline;
  }
}

.bulletinWai {
  overflow: auto;
  height: 211px;
  border-bottom: 1px solid #ccc;
}

.bulletin {
  padding: 12px;

  .top {
    img {
      width: 20px;
      border-radius: 50%;
      vertical-align: middle;
    }

    span {
      margin-left: 6px;
      color: #777;
    }

    em {
      color: #777;
      float: right;
      font-style: normal;
    }
  }

  .text {
    padding-left: 28px;
  }
}

.redColor {
  color: #FF6969;
}

.greenColor {
  color: #43E97B;
}
</style>
